import {
  commonMandatoryParams,
  commonOptionalParams,
  ParameterProps,
} from './common-params';
import { FormLayout } from '../../../quest/program-wizard/common';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  GridItem,
  SimpleGrid,
} from '@chakra-ui/react';

import { Select } from '@ssar-app/uikit';
import { Controller } from 'react-hook-form';

export const PreSelectParams = (props: ParameterProps) => {
  const { errors, control } = props.formMethods;

  return (
    <>
      <FormLayout header='Mandatory Parameters'>
        <SimpleGrid columns={1} ml={10}>
          {commonMandatoryParams(props)}
        </SimpleGrid>
      </FormLayout>
      <FormLayout header='Optional Parameters'>
        <SimpleGrid columns={1}>
          {commonOptionalParams(props)}
          <Box>
            <FormControl isInvalid={!!errors.marketSwitchFlag} mb={6}>
              <Grid templateColumns='repeat(4,1fr)'>
                <GridItem justifyContent='end' display='flex'>
                  <FormLabel>Trigger MarketSwitch jobs : </FormLabel>
                </GridItem>
                <GridItem colSpan={3}>
                  <Controller
                    name='marketSwitchFlag'
                    defaultValue={props.model?.marketSwitchFlag || 'N'}
                    control={control}
                    render={({ value, onChange }) => (
                      <Select
                        options={['Y', 'N'].map((val) => ({
                          label: val,
                          value: val,
                        }))}
                        defaultValue={value}
                        optionLabelProps={{ color: 'black' }}
                        selectContainerProps={{ width: 250 }}
                        // placeholder='Y'
                        onChange={(e) => {
                          onChange(e);
                          props.setModel({
                            ...props.model,
                            marketSwitchFlag: e as string,
                          });
                        }}
                      />
                    )}
                  ></Controller>
                  <FormErrorMessage>
                    {errors.marketSwitchFlag?.message}
                  </FormErrorMessage>
                  <FormHelperText fontSize='xs'>
                    Set this to Y if MarketSwitch job execution is required
                  </FormHelperText>
                </GridItem>
              </Grid>
            </FormControl>
          </Box>
        </SimpleGrid>
      </FormLayout>
    </>
  );
};
